import { Container } from 'reactstrap'
import { H5, Image } from '../../../../AbstractElements'
import { WeAreComingSoon } from '../../../../Utils/Constants'
import CountdownData from '../Common/CountdownData'
import { dynamicImage } from '../../../../Utils'

const ComingSoonWithBgImageContainer = () => {
  return (
    <div className="page-wrapper compact-wrapper" id="pageWrapper">
      <Container fluid className="p-0 m-0">
        <div className="comingsoon comingsoon-bgimg">
          <div className="comingsoon-inner text-center">
            <Image className="for-light" src={dynamicImage("other-images/logo-login.png")} alt="coming soon" />
            <Image className="for-dark mx-auto" src={dynamicImage("other-images/logo-light.png")} alt="coming soon" />
            <H5>{WeAreComingSoon}</H5>
            <div className="countdown" id="clockdiv">
              <CountdownData />
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default ComingSoonWithBgImageContainer